// PLAN-cockpit-v2 Phase 0-C: 共通 EmptyState (空状態 guidance)
import type { ReactNode } from 'react'

interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
  icon?: ReactNode
}

export function EmptyState({ title, description, action, icon }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-8 gap-3">
      {icon && <div className="text-3xl text-text-subtle mb-2" aria-hidden>{icon}</div>}
      <h3 className="text-md font-medium text-text-base">{title}</h3>
      {description && <p className="text-sm text-text-muted max-w-md">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  )
}
